import { spacings, colors, fontSizes, fontWeights, responsiveBreakPoints } from '@styles/DesignVariables';
import styled from 'styled-components';
const { maxTablet } = responsiveBreakPoints;

export const LovedLabelWrapper = styled.div<{ marginTop?: string }>`
	display: flex;
	padding: ${spacings.s8} ${spacings.s12};
	align-items: center;
	position: relative;
	gap: ${spacings.s4};
	width: fit-content;
	margin: ${({ marginTop }) => `${marginTop ?? '22px'} auto 0 auto`};
	border-radius: 10px;
	background: ${colors.whiteBackground};
	box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.15);
	@media screen and (${maxTablet}) {
		margin-top: 18px;
	}

	&::before {
		content: '';
		position: absolute;
		top: -6px;
		left: 50%;
		width: 0;
		height: 0;
		border-left: ${spacings.s6} solid transparent;
		border-right: ${spacings.s6} solid transparent;
		border-bottom: ${spacings.s6} solid #fff;
	}
`;

export const LovedLabelText = styled.p`
	color: ${colors.darkGrey};
	font-size: ${fontSizes.tinyParagraph};
	font-weight: ${fontWeights.semibold};
	line-height: 12px;
	margin: 0 !important;
`;
